import type { IScope } from "angular";
import { cloneDeep, get } from "lodash";
import { finalize } from "rxjs/operators";

import type { ILabel, IResponseWithLoading } from "App/Modules/Models";
import type { IPartnersRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EditPartnerLabelPopupComponentController {
    public static $inject: string[] = ["$scope", "mmPartnersRepository"];

    public originalLabel: ILabel;

    public editedLabel: ILabel;

    public labelToReplaceWith: ILabel = null;

    public labels: ILabel[];

    public labelNames: string[];

    public partnerId: string;

    public resolve: IFormContainerResolve<any, null>;

    public editResponse: IResponseWithLoading<ILabel>;

    public mergeResponse: IResponseWithLoading<void>;

    public deleteResponse: IResponseWithLoading<void>;

    constructor(private readonly $scope: IScope, private readonly partnersRepository: IPartnersRepository) {}

    public $onInit() {
        this.originalLabel = this.resolve.formData.updatedLabel;
        this.partnerId = get(this.resolve.bindings, "partnerId");
        this.labels = get(this.resolve.bindings, "labels");
        this.editedLabel = cloneDeep(this.originalLabel);
        this.labelNames = this.labels.map((item: ILabel) => item.label);
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public editPartnerUserLabel() {
        if (this.originalLabel.label !== this.editedLabel.label) {
            extendWithLoadingAndFail(this.partnersRepository.editLabel(this.partnerId, this.editedLabel))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response: IResponseWithLoading<ILabel>) => {
                        this.editResponse = response;
                        if (!response.isLoading && response.data) {
                            this.resolve.options.onOk({
                                updatedLabel: response.data,
                            });
                        }
                    },
                    (error) => {
                        this.editResponse = error;
                    },
                );
        } else if (this.labelToReplaceWith) {
            extendWithLoadingAndFail(
                this.partnersRepository.replaceLabel(this.partnerId, this.labelToReplaceWith.id, this.originalLabel.id),
            )
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response: IResponseWithLoading<void>) => {
                        this.mergeResponse = response;
                        if (!response.isLoading) {
                            this.resolve.options.onOk({
                                updatedLabel: this.labelToReplaceWith,
                                removedLabel: this.originalLabel,
                            });
                        }
                    },
                    (error) => {
                        this.mergeResponse = error;
                    },
                );
        } else {
            this.cancel();
        }
    }

    public removeLabel(): void {
        extendWithLoadingAndFail(this.partnersRepository.removeLabel(this.partnerId, this.originalLabel.id))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<void>) => {
                    this.deleteResponse = response;
                    if (!response.isLoading) {
                        this.resolve.options.onOk({
                            removedLabel: this.originalLabel,
                        });
                    }
                },
                (error) => {
                    this.deleteResponse = error;
                },
            );
    }
}
